import { render, staticRenderFns } from "./UnidadeAreasTable.vue?vue&type=template&id=0faea48b&"
import script from "./UnidadeAreasTable.vue?vue&type=script&lang=js&"
export * from "./UnidadeAreasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports